import {
  type BillableWeightResponse,
  type BillableWeightRequestBody,
  type DefaultQueryError,
  estimateBillableWeightFn,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useEstimateBillableWeight = (
  opts?: UseMutationOptions<
    BillableWeightResponse,
    DefaultQueryError,
    BillableWeightRequestBody
  >
) =>
  useMutation<
    BillableWeightResponse,
    DefaultQueryError,
    BillableWeightRequestBody
  >({
    mutationFn: estimateBillableWeightFn,
    ...opts,
  });
